export default __webpack_public_path__ + "static/media/water.ff086af1.svg";